import { render, staticRenderFns } from "./ksCardList.vue?vue&type=template&id=29d91e96&scoped=true"
import script from "./ksCardList.vue?vue&type=script&lang=js"
export * from "./ksCardList.vue?vue&type=script&lang=js"
import style0 from "./ksCardList.vue?vue&type=style&index=0&id=29d91e96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d91e96",
  null
  
)

export default component.exports